import { Button } from 'components/button/Button'
import {
  SButtonsDiv,
  SComposerModal,
  SHeading,
  SMemoryList,
  STitle,
} from './SelectFromGalleryModal.styled'
import { Icon } from 'components/icon'
import {
  getMemoryGalleryTab,
  MemorySelectOption,
  SelectedMemory,
} from 'components/memory/MemoryUtils'
import { BlockSpinner } from 'components/spinner/Spinner'
import { ReactNode, useState } from 'react'
import { useWindowSize } from 'utils/hooks'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'
import { useTranslation } from 'next-i18next'

export const SelectFromGalleryModal = (props: {
  onClose: () => void
  onMemoriesSelected?: (value: SelectedMemory[]) => void
  actions?: ReactNode
  placeholder?: ReactNode
  mode: MemorySelectOption
  defaultValue?: SelectedMemory[]
}) => {
  const { t, isLoading } = useDynamicTranslations('memory')
  const { t: tCommon } = useTranslation()
  const [value, setValue] = useState<SelectedMemory[]>(props.defaultValue || [])
  const { isDesktop } = useWindowSize()

  const tabs = getMemoryGalleryTab(tCommon)

  if (isLoading) return <BlockSpinner />
  return (
    <SComposerModal>
      <SHeading>
        {isDesktop && <Icon name="Plus" size="2rem" />}
        <STitle>{t('memory.gallery_modal.title')}</STitle>
      </SHeading>

      <SMemoryList
        defaultTab={tabs.all}
        tabs={[tabs.all]}
        value={value}
        onChange={setValue}
        customActions={props.actions}
        selectionMode={props.mode}
        hideTabs
      />

      <SButtonsDiv>
        <Button
          type="button"
          size="large"
          disabled={!value.length}
          onClick={() => {
            props.onMemoriesSelected?.(value)
            props.onClose()
          }}
        >
          {t('memory.gallery_modal.continue_button')}
        </Button>
      </SButtonsDiv>
    </SComposerModal>
  )
}
